<template>
  <PartsModal/>
  <PartsHeader/>
  
  <PartsFirstView/>
  
  <article id="about-circumstance" class="container">
    <section class="inner lowered">
      <PartsAboutCircumstance/>
    </section>
  </article>
  
  <article id="about-us" class="container js-scroll fade-in-bottom">
    <section class="inner raised">
      <PartsAboutUs/>
    </section>
  </article>
  
  <article id="about" class="container js-scroll fade-in-bottom">
    <section class="outer has-text-centered">
      <h2 class="title is-4 has-background-theme-green has-text-white is-inline-block p-4 px-5  sp-title">補助事業で取り組める木製品</h2>
    </section>
    <section class="inner">
      <PartsAboutFullOrder/>
    </section>
  </article>
  
  <article class="container js-scroll fade-in-bottom">
    <section class="inner lowered">
      <PartsAboutSemiOrder/>
    </section>
    
    <div class="ikonie js-scroll fade-in-bottom">
      <section class="inner py-0">
        <PartsAboutSemiOrderBrand/>
      </section>
    </div>
  </article>
  
  <article id="facilities" class="container js-scroll fade-in-bottom">
    <section class="outer has-text-centered">
      <h2 class="title is-4 has-background-theme-green has-text-white is-inline-block p-4 px-5  sp-title">木製品事例</h2>
    </section>
    <section class="inner raised lowered">
      <!-- <PartsDetail :contents="config.FILL_ORDER_CONTENTS" :chunk-num="3" :is-fixed="true" class="is-hidden-mobile" /> -->
      <PartsDetail :contents="config.FILL_ORDER_CONTENTS" :chunk-num="1" :is-horizontal="true" class="is-hidden-mobile" />
      <PartsDetail :contents="config.FILL_ORDER_CONTENTS" :chunk-num="1" class="is-hidden-tablet" />
    </section>
  </article>

  <article id="facilities-semi-order" class="container js-scroll fade-in-bottom has-background-theme-grey">
    <section class="inner lowered">
      <PartsDetail :contents="config.SEMI_ORDER_CONTENTS" :chunk-num="1" :is-horizontal="true" class="is-hidden-mobile" />
      <!-- <PartsDetail :contents="config.SEMI_ORDER_CONTENTS" :chunk-num="3" :is-fixed="true" class="is-hidden-mobile" /> -->
      <PartsDetail :contents="config.SEMI_ORDER_CONTENTS" :chunk-num="1" class="is-hidden-tablet" />
      <h3 class="is-over-under-line mb-6">
        <p class="is-size-6 lh-5">子どもたちにとって子育て施設は1日の大半を過ごす場所。<br>子どもたちが過ごす空間にはほんものの木を使った木製品が最適だと私たちは想っています。</p>
      </h3>
    </section>
  </article>

  <article id="flow" class="container js-scroll fade-in-bottom">
    <section class="outer has-text-centered">
      <h2 class="title is-4 has-background-theme-green has-text-white is-inline-block p-4 px-5  sp-title">補助事業を利用した木製品導入の流れ</h2>
    </section>
    <section class="inner raised">
      <PartsFlow/>
    </section>
  </article>
  
  <article class="container js-scroll fade-in-bottom">
    <section class="inner">
      <PartsAccordionBox :is-show="isShowAboutOsakazai" @toggle="isShowAboutOsakazai = !isShowAboutOsakazai;" class="is-align-items-center is-justify-content-center">
        <template v-slot:title>
          <div class="has-text-centered">未来につなぐ大阪府内産木材</div>
        </template>
        <template v-slot:body>
          <PartsAboutOsakazai/>
        </template>
      </PartsAccordionBox>
    </section>
  </article>
  
  <article id="interview" class="container js-scroll fade-in-bottom">
    <section class="outer has-text-centered">
      <h2 class="title is-4 has-background-theme-green has-text-white is-inline-block p-4 px-5  sp-title">インタビュー</h2>
    </section>
    <section class="inner raised lowered">
      <PartsInterview/>
    </section>
  </article>
  
  <article id="detail" class="container js-scroll fade-in-bottom">
    <section class="outer has-text-centered">
      <h2 class="title is-4 has-background-theme-green has-text-white is-inline-block p-4 px-5  sp-title">補助事業詳細案内</h2>
    </section>
    <section class="inner mt-6 pt-3">
      <PartsAboutGrant/>
    </section>
  </article>

  <article id="faq" class="container js-scroll fade-in-bottom">
    <section class="outer has-text-centered">
      <h2 class="title is-4 has-background-theme-green has-text-white is-inline-block p-4 px-5  sp-title">よくある質問</h2>
    </section>
    <section class="inner raised">
      <PartsFaqLink/>
    </section>
  </article>

  <article id="consultation" class="container js-scroll fade-in-bottom">
    <section class="outer has-text-centered">
      <h2 class="title is-4 has-background-theme-green has-text-white is-inline-block p-4 px-5  sp-title">補助事業を活用した木製品導入相談</h2>
    </section>
    <section class="inner pt-6 mt-3">
      <h3 class="mb-6 consultation-text is-hidden-mobile">
               
        <span>『大阪府内産木材』を使った木製品の導入に対する費用の</span><br><span>半分（上限５０万円）を大阪府が補助します</span>
      </h3>
      <h3 class="mb-6 consultation-text is-hidden-tablet">
        <span>『大阪府内産木材』を使った<br>木製品の導入に対する費用の</span><br><span>半分（上限５０万円）を大阪府が補助します</span>
      </h3>

      <PartsConsultation/>
    </section>
  </article>
  
  <article id="contact" class="container js-scroll fade-in-bottom">
    <section class="inner">
      <PartsAccordionBox :is-show="isShowContact" @toggle="isShowContact = !isShowContact;" class="is-align-items-center is-justify-content-center">
        <template v-slot:title>
          <div class="has-text-centered">補助事業を使った木製品・設備導入相談フォーム</div>
        </template>
          <template v-slot:body>
           <h3 class="is-over-under-line my-6">
            <p class="title is-6 mb-2">申請期限まで余裕がない場合などお急ぎの場合はお電話ください</p>
            <p class="title is-4">電話お問い合わせ先&emsp;TEL: 06-6696-7551</p>
            <!-- <a class="modal-btn">プライバシポリシー</a> -->
          </h3>
          <PartsContactIFrame/>
        </template>
      </PartsAccordionBox>
    </section>
  </article>

  <PartsFooter/>
</template>

<script>
import config from './config.json';  

import PartsHeader from './components/PartsHeader.vue';
import PartsFirstView from './components/PartsFirstView.vue';
import PartsAboutCircumstance from './components/PartsAboutCircumstance.vue';
import PartsAboutUs from './components/PartsAboutUs.vue';
import PartsAboutFullOrder from './components/PartsAboutFullOrder.vue';
import PartsAboutSemiOrder from './components/PartsAboutSemiOrder.vue';
import PartsAboutSemiOrderBrand from './components/PartsAboutSemiOrderBrand.vue';
import PartsDetail from './components/PartsDetail.vue';
import PartsFlow from './components/PartsFlow.vue';
import PartsAboutOsakazai from './components/PartsAboutOsakazai.vue';
import PartsInterview from './components/PartsInterview.vue';
import PartsAboutGrant from './components/PartsAboutGrant.vue';
import PartsFaqLink from './components/PartsFaqLink.vue';
import PartsConsultation from './components/PartsConsultation.vue';
import PartsContactIFrame from './components/PartsContactIFrame.vue';
import PartsFooter from './components/PartsFooter.vue';
import PartsAccordionBox from './components/PartsAccordionBox.vue';
import PartsModal from './components/PartsModal.vue';

export default {
  name: 'App',
  components: {
    PartsHeader,
    PartsFirstView,
    PartsAboutCircumstance,
    PartsAboutUs,
    PartsAboutFullOrder,
    PartsAboutSemiOrder,
    PartsAboutSemiOrderBrand,
    PartsDetail,
    PartsFlow,
    PartsAboutOsakazai,
    PartsInterview,
    PartsAboutGrant,
    PartsFaqLink,
    PartsConsultation,
    PartsContactIFrame,
    PartsFooter,
    PartsAccordionBox,
    PartsModal
  },
  data() {
    return {
      isShowContact: true,
      isShowAboutOsakazai: true,
    };
  },
  computed: {
    config() {
      return config;
    }
  }
}
</script>

<style scoped>
#app {
  overflow: hidden;
}

.ikonie {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: url("./assets/img/about_semi_order_background.jpg");
}

.ikonie {
  margin-bottom:9rem;
}

.consultation-text {
  letter-spacing: 0.01em;
  line-height: 2;
  font-weight: bold;
  font-size: 1.875rem;
  text-align: center;
  background-color: #F0F2F5;
  padding: 3%;
  position: relative;
  z-index: 1;
}

.consultation-text::after {
  content: "";
  display: block;
  position: absolute;
  background: url("./assets/img/consultation_bg.png");
  width: 110px;
  height: 110px;
  background-size: contain;
  background-repeat: no-repeat;
  top: 50%;
  right: 3%;
  transform: translateY(-50%);
  z-index: -1;
}

.consultation-text span {
  padding-bottom: 4px;
  background: linear-gradient(transparent 60%, #FAFFAF 0%);
}



@media all and (min-width: 1024px) and (max-width: 1280px) {
.ikonie {
  margin-bottom:6rem;
}
}
 
@media all and (min-width: 768px) and (max-width: 1024px) {
.ikonie {
  margin-bottom:6rem;
}
} 
@media all and (min-width: 480px) and (max-width: 768px) {
.ikonie {
  margin-bottom:3rem;
}

  .fv-caption {
    width: 100%;
  }

  .navbar-item img {
    height: 70px;
  }



}

@media all and (max-width: 1024px) {

  .consultation-text {
    font-size: 1.5rem;
  }
}

@media all and (max-width: 768px) {

  .consultation-text {
    font-size: 1.25rem;
  }
}
 
@media all and (max-width: 480px) {
.ikonie {
  margin-bottom:3rem;
}

  .navbar-item img {
    height: 65px;
  }

  .navbar-item {
    padding: 0.8em 0.75em;
  }
}

@import "./css/style.css";
</style>
